import type { ChampClass } from "../types";
import { ClassCreate } from "./ClassCreate";
import { ClassEdit } from "./ClassEdit";
import { ClassList } from "./ClassList";
import { ClassShow } from "./ClassShow";

export { classesMessages } from "./classesMessages";

export default {
  list: ClassList,
  create: ClassCreate,
  edit: ClassEdit,
  show: ClassShow,
  recordRepresentation: (record: ChampClass) =>
    record.program_name
      ? `${record.program_name} – ${record.name}`
      : record.name,
};
